// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalView_modalContainer__E-1kl","modalFullscreen":"ModalView_modalFullscreen__SQxrm"};